import menuItems from 'menu-items';

function titleFromMenuItems(items, pathname) {
  for (const item of items || []) {
    if (item.type === 'item' && item.url === pathname) {
      return item.title || '';
    }
    if (item.children) {
      const nested = titleFromMenuItems(item.children, pathname);
      if (nested) return nested;
    }
  }
  return '';
}

function titleFromPathSegment(pathname) {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 0) return 'Dashboard';
  const segment = parts[parts.length - 1];
  return segment
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Resolve the current page label from navigation (falls back to the URL segment). */
export function getPageTitleFromPath(pathname = '') {
  const path = String(pathname).split('?')[0] || '/';

  for (const group of menuItems.items || []) {
    if (group.type === 'group' && group.children) {
      const title = titleFromMenuItems(group.children, path);
      if (title) return title;
    }
  }

  if (path === '/' || path === '') {
    return titleFromMenuItems(menuItems.items?.[0]?.children, '/reef-dashboard') || 'Dashboard';
  }

  return titleFromPathSegment(path);
}
